import api from "../api";

const api_type = 'v1'

export const GetSpendSelfChannel = params => { return api.post(api_type+`/spend_self/channel_list`, params) }
export const AddSpendSelfChannel = params => { return api.post(api_type+`/spend_self/channel_add`, params) }
export const StatusSpendSelfChannel = params => { return api.post(api_type+`/spend_self/channel_status`, params) }
export const GetSpendSelf = params => { return api.post(api_type+`/spend_self/get_list`, params) }
export const AddSpendSelf = params => { return api.post(api_type+`/spend_self/add`, params) }
export const DeleteSpendSelf = params => { return api.post(api_type+`/spend_self/delete`, params) }
export const EditSpendSelf = params => { return api.post(api_type+`/spend_self/edit`, params) }




// WEBPACK FOOTER //
// ./src/api/v1/spend_self_api.js